import React from "react";
import {FilterableColumn, FilterRule} from "../../styledTableHelper";
import FilterDropdown from "./filterDropdown/FilterDropdown";
import FilterInput from "./filterInput/FilterInput";
import ClearIcon from "@mui/icons-material/Clear";

import styles from "./FilterFields.module.scss";

type FilterInputsProps = {
  filterableColumns: FilterableColumn[];
  draftFilterRules: FilterRule[];
  setDraftFilterRules: (rules: FilterRule[]) => void;
};

export default function FilterInputs({
  filterableColumns,
  draftFilterRules,
  setDraftFilterRules,
}: FilterInputsProps) {
  const updateFilterRules = (rule: FilterRule) => {
    const existingIndex = draftFilterRules.findIndex(
      (r) => r.columnId === rule.columnId
    );

    if (existingIndex !== -1) {
      const updated = [...draftFilterRules];
      updated[existingIndex] = rule;
      setDraftFilterRules(updated);
    } else {
      setDraftFilterRules([...draftFilterRules, rule]);
    }
  };

  const draftFilterRulesColumnInfo = draftFilterRules.map((rule) => {
    const column = filterableColumns.find((c) => c.columnId === rule.columnId);
    return {
      column: column as FilterableColumn,
      rule: rule as FilterRule,
    };
  });

  const clearFilterRule = (columnId: string) => {
    const updatedFilterRules = draftFilterRules.filter(
      (r) => r.columnId !== columnId
    );
    setDraftFilterRules(updatedFilterRules);
  };

  return (
    <div className={styles.filterFieldsContainer}>
      {draftFilterRulesColumnInfo.map((col) => (
        <div
          key={`${col.column.columnId}-filter-field`}
          className={styles.filterFieldContainer}
        >
          {col.column?.columnType === "select" ? (
            <FilterDropdown
              column={col.column}
              draftFilterRules={draftFilterRules}
              updateDraftFilterRules={updateFilterRules}
            />
          ) : (
            <FilterInput
              column={col.column}
              draftFilterRules={draftFilterRules}
              updateDraftFilterRules={updateFilterRules}
            />
          )}
          <ClearIcon
            className={styles.clearIcon}
            onClick={() => clearFilterRule(col.column.columnId)}
          />
        </div>
      ))}
    </div>
  );
}
